const routes = {
  dashboard: {
    base: "/dashboard/:clubId",
    assessment: "/dashboard/:clubId/assessment",
    learning: "/dashboard/:clubId/learning",
    teachers: "/dashboard/:clubId/teachers/:orgId",
  },
  settings: "/settings",
} as const

export const getRouteDisplayName = (route: string): string => {
  switch (route) {
    case routes.dashboard.base:
      return "Dashboard"
    case routes.dashboard.teachers:
      return "Teachers"
    case routes.dashboard.assessment:
      return "Assessment"
    case routes.dashboard.learning:
      return "Learning"
    default:
      throw new Error(`Unknown route: ${route}`)
  }
}

type GetRouteParams<T extends string> =
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  T extends `${infer _start}:${infer Param}/${infer rest}`
    ? Param | GetRouteParams<`/${rest}`>
    : // eslint-disable-next-line @typescript-eslint/no-unused-vars
      T extends `${infer _start}:${infer Param}`
      ? Param
      : never

type RouteParams<T extends string> = {
  [K in GetRouteParams<T>]: string
}
export const routeBuilder = <T extends string>(
  route: T,
  params?: RouteParams<T>,
  queryParams?: Record<string, string | number>,
): string => {
  let r = route as string
  if (params) {
    for (const key in params) {
      r = r.replace(`:${key}`, params[key as keyof typeof params])
    }
  }

  if (queryParams) {
    const searchParams = new URLSearchParams()
    Object.entries(queryParams).forEach(([key, value]) => {
      searchParams.append(key, value.toString())
    })
    r += `?${searchParams.toString()}`
  }

  return r
}

export default routes
